import { mergeTranslations } from "ra-core";
import polyglotI18nProvider from "ra-i18n-polyglot";
import { englishCatalog } from "@/components/atomic-crm/providers/commons/i18nProvider";

// Everyday navigation and actions first; other screens retain upstream English.
const italianMessages = {
  ra: {
    page: { dashboard: "Oggi" },
    action: {
      add: "Aggiungi",
      back: "Indietro",
      cancel: "Annulla",
      close: "Chiudi",
      confirm: "Conferma",
      create: "Crea",
      delete: "Elimina",
      edit: "Modifica",
      export: "Esporta",
      filter: "Filtra",
      list: "Elenco",
      refresh: "Aggiorna",
      remove: "Rimuovi",
      save: "Salva",
      search: "Cerca",
      show: "Apri",
      sort: "Ordina",
    },
    validation: { required: "Campo obbligatorio" },
    auth: { logout: "Esci" },
  },
  resources: {
    contacts: {
      name: "Contatto |||| Contatti",
      forcedCaseName: "Contatto",
      fields: {
        first_name: "Nome",
        last_name: "Cognome",
        title: "Ruolo",
        company_id: "Azienda",
        background: "Informazioni e contesto",
        sales_id: "Responsabile",
        last_seen: "Ultima attività",
      },
      action: {
        add: "Aggiungi contatto",
        create: "Crea contatto",
        edit: "Modifica contatto",
        new: "Nuovo contatto",
        show: "Apri contatto",
      },
      hot: { title: "Contatti caldi" },
    },
    companies: {
      name: "Azienda |||| Aziende",
      forcedCaseName: "Azienda",
      fields: {
        name: "Nome azienda",
        website: "Sito web",
        sector: "Settore",
        sales_id: "Responsabile",
        description: "Descrizione",
      },
      action: {
        create: "Crea azienda",
        edit: "Modifica azienda",
        new: "Nuova azienda",
        show: "Apri azienda",
      },
    },
    deals: {
      name: "Trattativa |||| Trattative",
      forcedCaseName: "Trattativa",
      fields: {
        name: "Nome trattativa",
        company_id: "Azienda",
        contact_ids: "Referenti",
        category: "Servizio",
        stage: "Fase",
        description: "Descrizione",
        amount: "Valore della proposta",
        expected_closing_date: "Chiusura prevista",
        sales_id: "Responsabile",
      },
      action: {
        create: "Crea trattativa",
        new: "Nuova trattativa",
        back_to_deal: "Torna alla trattativa",
      },
      archived: { view: "Mostra archiviate" },
    },
    notes: {
      name: "Nota |||| Note",
      forcedCaseName: "Nota",
      fields: { status: "Interesse", date: "Data", attachments: "Allegati" },
      action: {
        add: "Aggiungi nota",
        edit: "Modifica nota",
        delete: "Elimina nota",
        add_this: "Salva nota",
      },
      empty: "Nessun aggiornamento per ora.",
      added: "Nota salvata",
      author_added: "%{name} ha aggiunto una nota",
      you_added: "Hai aggiunto una nota",
      me: "Io",
      inputs: {
        add_note: "Scrivi una nota",
        show_options: "Allega un file o cambia data",
        options_hint: "",
      },
      actions: { attach_document: "Allega documento" },
    },
    tasks: {
      name: "Attività |||| Attività",
      forcedCaseName: "Attività",
      fields: {
        text: "Descrizione",
        due_date: "Scadenza",
        type: "Tipo",
        contact_id: "Contatto",
        due_short: "entro",
      },
      action: {
        add: "Aggiungi attività",
        create: "Crea attività",
        edit: "Modifica attività",
      },
      filters: {
        later: "Più avanti",
        overdue: "Scadute",
        this_week: "Questa settimana",
        today: "Oggi",
        tomorrow: "Domani",
      },
      empty: "Nessun prossimo passo programmato.",
      empty_list_hint:
        "Qui troverai i ricontatti e le attività aggiunti ai clienti.",
      added: "Attività aggiunta",
      updated: "Attività aggiornata",
      dialog: {
        create: "Aggiungi attività",
        create_for: "Attività per %{name}",
      },
      sheet: { edit: "Modifica attività", edit_for: "Attività per %{name}" },
      regarding_contact: "(per %{name})",
    },
    sales: { name: "Utente |||| Utenti" },
  },
  crm: {
    language: "Lingua",
    navigation: { label: "Navigazione principale" },
    profile: { title: "Profilo" },
    settings: { title: "Impostazioni" },
    common: {
      account_manager: "Responsabile",
      activity: "Attività",
      details: "Dettagli",
      load_more: "Mostra altre",
      me: "Io",
      loading: "Caricamento…",
      retry: "Riprova",
    },
    dashboard: {
      deals_chart: "Valore delle trattative",
      deals_pipeline: "Trattative aperte",
      latest_activity: "Ultimi aggiornamenti",
      upcoming_tasks: "Prossime attività",
    },
    search: {
      title: "Cerca",
      placeholder: "Cerca contatti, aziende, trattative, attività e note…",
      groups: {
        contacts: "Contatti",
        companies: "Aziende",
        deals: "Trattative",
        tasks: "Attività",
        contact_notes: "Note dei contatti",
        deal_notes: "Note delle trattative",
      },
    },
  },
};

const italian = mergeTranslations(englishCatalog, italianMessages);

export const narsI18nProvider = polyglotI18nProvider(
  (locale) => (locale === "it" ? italian : englishCatalog),
  "it",
  [
    { locale: "it", name: "Italiano" },
    { locale: "en", name: "English" },
  ],
  { allowMissing: true },
);
